import { z } from "zod";

import { AuthorSchema } from "@shared/ui/author";

// Slot Details component schema
export const SlotDetailsSchema = z.object({
  id: z.number().optional(),
  description: z.string().nullable(),
  speaker: AuthorSchema.nullable(),
});

// Time Slot component schema
export const TimeSlotSchema = z.object({
  id: z.number().optional(),
  time: z.string().nullable(),
  slotDetails: SlotDetailsSchema.nullable(),
});

// Sector component schema
export const SectorSchema = z.object({
  id: z.number().optional(),
  sectorName: z.string().nullable(),
  timeSlot: z.array(TimeSlotSchema),
});

// Event Program component schema
export const EventProgramSchema = z.object({
  id: z.number().optional(),
  title: z.string().nullable(),
  sector: z.array(SectorSchema),
});

// Export types
export type SlotDetails = z.infer<typeof SlotDetailsSchema>;
export type TimeSlot = z.infer<typeof TimeSlotSchema>;
export type Sector = z.infer<typeof SectorSchema>;
export type EventProgram = z.infer<typeof EventProgramSchema>;
